import { Button } from 'antd';
import styled from 'styled-components';

export default styled(Button)`
	// Add your styles here
`;
